import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
// redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import CommentsList from '../../comment/commentsList';
import FeedbackFilter from './feedbackFilter';
import { uxAnalyticsUtil, authUtil } from '../../../utils';
import {
  fetchComments,
  fetchMoreComments,
  clearCommentList
} from '../../../modules/comment';
import LoadMore from '../../../components/lists/loadMore';

const limit = 50;
const lastSupport = true;

export class Feedback extends Component {
  constructor(props) {
    super(props);

    this.state = {
      notes: [],
      ratings: [],
      statistics: [],
      isLoading: false,
      search: undefined
    };
  }

  componentDidMount() {
    const { match } = this.props;
    uxAnalyticsUtil.trackPageView(match.path);
    this.fetchComments();
  }

  componentDidUpdate(prevProps, prevState) {
    const { sort, search } = this.state;
    if (sort !== prevState.sort || search !== prevState.search) {
      this.fetchComments();
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { location } = nextProps;
    if (!location) {
      return;
    }
    const query = queryString.parse(location.search);
    const { search } = query;
    if (prevState.search !== search) {
      return {
        ...prevState,
        search
      }
    };
    return {
      ...prevState
    };
  }

  fetchComments = async () => {
    const {
      user, match
    } = this.props;
    const idToken = await authUtil.getFreshIdToken();
    const { bookId } = match.params;
    const { search, sort = 'desc' } = this.state;
    if (idToken !== undefined && user !== undefined) {
      this.props.fetchComments(idToken, bookId, undefined, {
        sort, search, limit, lastSupport
      });
    }
  }

  fetchMoreComments = async () => {
    const {
      user, match, comments
    } = this.props;
    const idToken = await authUtil.getFreshIdToken();
    const { bookId } = match.params;
    const { search, sort = 'desc' } = this.state;
    if (idToken !== undefined && user !== undefined) {
      this.props.fetchMoreComments(idToken, bookId, undefined, {
        sort, search, limit, skip: comments.length, lastSupport
      });
    }
  }

  render() {
    const {
      isLoading, search
    } = this.state;
    const { book, comments } = this.props;
    if (!isLoading) {
      return (
        <main style={{maxWidth: 960, margin: '0 auto', padding: '1rem'}}>
          <FeedbackFilter book={book} />
          <CommentsList
            search={search}
            sort='desc'
            disableLeavingComments
            enableLeavingReplies
            showChapterLinks
          />
          {comments?.length > 0 && !comments[comments.length - 1].isLast && (
            <LoadMore onLoadMore={this.fetchMoreComments} loading={isLoading} />
          )}
        </main>
      )
    }
    return (
      <main style={{maxWidth: 960, margin: '0 auto', padding: '1rem'}}>
        <p role='status'>Loading…</p>
      </main>
    )
  }
}


// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  currentBook: state.book.currentBook,
  comments: state.comment.comments
});

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchComments,
  fetchMoreComments,
  clearCommentList
}, dispatch);

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Feedback));
